module.exports = __webpack_public_path__ + "img/event-log.a6ee7158.svg";